import http from 'conversations-http/clients/http';
import get from 'transmute/get';
export const fetchInboxName = inboxId => http.get(`/messages/v2/inbox/${inboxId}?allowDeleted=true`).then(inboxData => get('name', inboxData));